import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import tagsApi from '@/features/dashboard/tags/api/tagsApi.ts';
import { tagsApiQueryKeys } from '@/features/dashboard/tags/api/tagsApi.queryKeys.ts';
import { TaggableType } from '@/features/dashboard/tags/types/TaggableType.ts';

/**
 * Assigns a tag (by id) to a given target. The endpoint is idempotent.
 * `onMutated` lets callers (e.g. a table cell) refresh extra queries.
 */
const useAssignTag = (
  targetType: TaggableType,
  targetId: string,
  options?: { onMutated?: () => void },
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (tagId: string) =>
      tagsApi.assign({ tagId, targetType, targetId }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: tagsApiQueryKeys.forTarget(targetType, targetId),
      });
      options?.onMutated?.();
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description: error.message || 'Nie udało się przypisać tagu.',
      });
    },
  });
};

export default useAssignTag;
